import { render, staticRenderFns } from "./LisansSuresiOverlay.vue?vue&type=template&id=7961baf8&scoped=true"
import script from "./LisansSuresiOverlay.vue?vue&type=script&lang=ts"
export * from "./LisansSuresiOverlay.vue?vue&type=script&lang=ts"
import style0 from "./LisansSuresiOverlay.vue?vue&type=style&index=0&id=7961baf8&prod&scoped=true&lang=css"
import style1 from "./LisansSuresiOverlay.vue?vue&type=style&index=1&id=7961baf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7961baf8",
  null
  
)

export default component.exports